function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 6.451612903225806,
  cy: 33.6848,
  r: 2.79041
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-0.5s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "0s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-0.5s"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 6.451612903225806,
  cy: 66.3152,
  r: 3.20959
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.5s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-0.5s"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 16.129032258064512,
  cy: 32.0313,
  r: 3.03041
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-0.7s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-0.2s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-0.7s"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 16.129032258064512,
  cy: 67.9687,
  r: 2.96959
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.7s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.2s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-0.7s"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25.806451612903224,
  cy: 34.9601,
  r: 3.27041
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-0.9s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-0.4s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-0.9s"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25.806451612903224,
  cy: 65.0399,
  r: 2.72959
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.9s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.4s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-0.9s"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 35.48387096774193,
  cy: 44.7518,
  r: 3.51041
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.1s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-0.6s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.1s"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 35.48387096774193,
  cy: 55.2482,
  r: 2.48959
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2.1s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.6s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.1s"
}));

var _ref9 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 45.16129032258064,
  cy: 58.4506,
  r: 3.44959
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.3s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-0.8s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.3s"
}));

var _ref10 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 45.16129032258064,
  cy: 41.5494,
  r: 2.55041
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2.3s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.8s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.3s"
}));

var _ref11 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 54.838709677419345,
  cy: 66.3152,
  r: 3.20959
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.5s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.5s"
}));

var _ref12 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 54.838709677419345,
  cy: 33.6848,
  r: 2.79041
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2.5s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.5s"
}));

var _ref13 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 64.51612903225805,
  cy: 67.9687,
  r: 2.96959
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.7s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.2s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.7s"
}));

var _ref14 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 64.51612903225805,
  cy: 32.0313,
  r: 3.03041
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2.7s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2.2s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.7s"
}));

var _ref15 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 74.19354838709677,
  cy: 65.0399,
  r: 2.72959
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.9s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.4s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.9s"
}));

var _ref16 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 74.19354838709677,
  cy: 34.9601,
  r: 3.27041
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2.9s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2.4s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.9s"
}));

var _ref17 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 83.87096774193547,
  cy: 55.2482,
  r: 2.48959
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2.1s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.6s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2.1s"
}));

var _ref18 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 83.87096774193547,
  cy: 44.7518,
  r: 3.51041
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-3.1s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2.6s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2.1s"
}));

var _ref19 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 93.54838709677418,
  cy: 41.5494,
  r: 2.55041
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2.3s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-1.8s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2.3s"
}));

var _ref20 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 93.54838709677418,
  cy: 58.4506,
  r: 3.44959
}, React.createElement("animate", {
  attributeName: "r",
  times: "0;0.5;1",
  values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-3.3s"
}), React.createElement("animate", {
  attributeName: "cy",
  keyTimes: "0;0.5;1",
  values: "32;68;32",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2.8s",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "fill",
  keyTimes: "0;0.5;1",
  values: "#0080ff;#0080ff;#0080ff",
  dur: "2s",
  repeatCount: "indefinite",
  begin: "-2.3s"
}));

var SvgDnaSpinner = function SvgDnaSpinner(props) {
  return React.createElement("svg", _extends({
    className: "lds-dna",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

export default __webpack_public_path__ + "static/media/dna-spinner.ed8226a4.svg";
export { SvgDnaSpinner as ReactComponent };